<template>
  <div>
    <!-- Start: Progress Bar -->
    <vue-progress-bar></vue-progress-bar>
    <!-- End: Progress Bar -->
    <!-- Start: Wrapper -->
    <div id="wrapper" v-if="isAuthorized">
      <!-- Start: Navigation -->
      <Navigation></Navigation>
      <!-- End: Navigation -->
      <!-- Start: Header -->
      <Header></Header>
      <!-- End: Header -->
      <!-- Start: Content -->
      <router-view></router-view>
      <!-- End: Content -->
      <!-- Start: Footer -->
      <Footer></Footer>
      <!-- End: Footer -->
    </div>
    <!-- End: Wrapper -->
  </div>
</template>

<script>
import Header from "@/components/shared/Header";
import Navigation from "@/components/shared/Navigation";
import Footer from "@/components/shared/Footer";
import store from "@/store/index.js";

export default {
  name: "AppLayout",
  components: {
    Header,
    Navigation,
    Footer,
  },
  data() {
    return {
      isAuthorized: false,
    };
  },
  created() {
    this.authorize();
  },
  updated() {
    this.authorize();
    // HACK: treat normal textbox as a readonly element, value can't be edited manually
    Array.prototype.forEach.call(
      document.getElementsByClassName("readonly"),
      (element) => {
        element.addEventListener("keydown", (event) => {
          event.preventDefault();
        });
      }
    );
  },
  methods: {
    async authorize() {
      try {
        const user = await store.dispatch("user/getUser");
        if (user.active) {
          this.isAuthorized = user.active;
        } else {
          console.log("User not signed in");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/AppLayout.vue